import { createAction } from '@reduxjs/toolkit';

const setAuthUser = createAction('login/setAuthUser');
const clearUserData = createAction('login/clearUserData');

export default {
  setAuthUser,
  clearUserData,
};
